/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchPccDemographicsRequest } from './PatchPccDemographicsRequest';
import {
    PatchPccDemographicsRequestFromJSON,
    PatchPccDemographicsRequestFromJSONTyped,
    PatchPccDemographicsRequestToJSON,
    PatchPccDemographicsRequestToJSONTyped,
} from './PatchPccDemographicsRequest';

/**
 * 
 * @export
 * @interface GetPccDemographicsPrefill200Response
 */
export interface GetPccDemographicsPrefill200Response {
    /**
     * 
     */
    data?: PatchPccDemographicsRequest;
}

/**
 * Check if a given object implements the GetPccDemographicsPrefill200Response interface.
 */
export function instanceOfGetPccDemographicsPrefill200Response(value: object): value is GetPccDemographicsPrefill200Response {
    return true;
}

export function GetPccDemographicsPrefill200ResponseFromJSON(json: any): GetPccDemographicsPrefill200Response {
    return GetPccDemographicsPrefill200ResponseFromJSONTyped(json, false);
}

export function GetPccDemographicsPrefill200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPccDemographicsPrefill200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PatchPccDemographicsRequestFromJSON(json['data']),
    };
}

export function GetPccDemographicsPrefill200ResponseToJSON(json: any): GetPccDemographicsPrefill200Response {
    return GetPccDemographicsPrefill200ResponseToJSONTyped(json, false);
}

export function GetPccDemographicsPrefill200ResponseToJSONTyped(value?: GetPccDemographicsPrefill200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PatchPccDemographicsRequestToJSON(value['data']),
    };
}

